module.exports = __webpack_public_path__ + "static/media/addy-optimized.44117bb1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/03-what-is-a-static-site/images/addy-optimized.jpg
// module id = 934
// module chunks = 0